import type { LandingStrings } from './en';

export const de: LandingStrings = {
  header: {
    brandSubtitle: 'Zauberladen',
    contact: 'Kontakt',
    about: 'Über das Spiel',
    language: 'Sprache',
  },
  footer: {
    terms: 'Nutzungsbedingungen',
    privacy: 'Datenschutzerklärung',
    copyright: '{year} {holder}. Alle Rechte vorbehalten.',
  },
  home: {
    heroTitle: 'Ein gemütliches 3D-Spiel über Zaubertränke und einen magischen Laden.',
    heroDescription:
      'Suche Zutaten im magischen Durcheinander, braue Tränke im Kessel und verkaufe sie in deinem eigenen Laden.',
    features: [
      {
        title: 'Dein eigenes Fläschchen',
        desc: 'Form, Verschluss und Farbe des Tranks – hübsche Fläschchen bringen mehr ein.',
      },
      {
        title: 'Brauen mit Sinn',
        desc: 'Jeder Trank hat sein eigenes Rezept, und viele wirken im Spiel tatsächlich.',
      },
      {
        title: 'Eine Geschichte, die neugierig macht',
        desc: 'Oma ist in den Urlaub gefahren und hat dir ihren Laden überlassen – und ein Frosch namens Moren fordert, was ihm zusteht.',
      },
      {
        title: 'Ein Laden, der wirklich dir gehört',
        desc: 'Verkauft wird nur, was du selbst gebraut hast.',
      },
    ],
    appStore: 'App Store',
    googlePlay: 'Google Play',
    comingSoon: 'Erscheint bald',
    tags: { search: 'Schattensuche', craft: 'Tränke brauen in 3D', shop: 'Gemütlicher Laden' },
  },
  about: {
    title: 'Über Qevryno',
    intro: [
      'Willkommen bei Qevryno – einem gemütlichen Spiel rund ums Tränkebrauen, in dem Magie Handarbeit ist.',
      'Oma ist in den Urlaub gefahren und hat dich gebeten, auf ihr geheimnisvolles altes Haus aufzupassen: vergessene Rezepte, magische Zutaten und ein Kessel, der das Brodeln noch nicht verlernt hat. Unten gibt es einen kleinen Laden, und das ganze Dorf rätselt schon, wer sich jetzt um ihn kümmert.',
      'Braue Tränke, kümmere dich um deinen flauschigen Zauberkater, verkaufe deine Kreationen an charmante Kundschaft und verdiene Münzen, um dein magisches Zuhause zu schmücken – in deinem eigenen Tempo, ohne Timer.',
    ],
    whatTitle: 'Was für ein Spiel ist das?',
    what: [
      'Qevryno ist ein entspannendes 3D-Rätselspiel, das Wimmelbildsuche, Alchemie-Crafting und einen kleinen Ladensimulator verbindet. Wenn du gemütliche Spiele (Cozy Games), Casual-Rätselspiele, Wimmelbildspiele oder Spiele über Zaubertränke, Alchemie und einen eigenen Zauberladen magst, ist Qevryno dein Spiel.',
      'Qevryno ist ein Singleplayer-Spiel und funktioniert offline; Internet brauchst du nur für Käufe und optionale Belohnungsvideos. Keine Banner und keine Pop-up-Werbung: Ein kurzes Video von Google AdMob läuft nur, wenn du für einen Bonus darauf tippst. Optionale Käufe: Edelsteine und Zutatenpakete mit sichtbarem Inhalt. Erscheint bald für iOS und Android, auf Deutsch, Englisch, Russisch, Spanisch, Französisch, Niederländisch, Italienisch, Portugiesisch (Brasilien), Polnisch, Japanisch, Koreanisch, Chinesisch (traditionell) und Türkisch.',
    ],
    doTitle: 'Was du im Spiel machst',
    doList: [
      'Versteckte Zutaten auf magischen 3D-Waldlichtungen suchen – jede wie ein kleines Diorama.',
      'Magische Rezepte im Kessel brauen: ein Stabilisator, eine Hauptzutat, Zeitkräuter und ein Hauch Farbe.',
      'Eigene Fläschchen gestalten – Form, Verschluss und Farbe des Tranks; hübsche Fläschchen bringen mehr ein.',
      'Deinen eigenen Laden führen: Kundschaft, Ruf, Jahrmärkte und Quests.',
      'Die Geschichte verfolgen: Oma ist in den Urlaub gefahren und hat dir ihren Laden überlassen, und ein Frosch namens Moren fordert immer wieder, was ihm zusteht.',
      'Fundstücke im Mörser zerreiben, in der Schale mischen und Glitzer dazugeben – jede Mischung hat ihre eigene Textur und Farbe.',
      'Deinen Zauberkater füttern und den Laden dekorieren.',
    ],
    faqTitle: 'Häufige Fragen',
    faq: [
      { q: 'Ist Qevryno kostenlos?', a: 'Ja. Das Spiel ist kostenlos und lässt sich ohne Bezahlen spielen. Optionale Käufe: Edelsteine und Zutatenpakete.' },
      { q: 'Funktioniert das Spiel offline?', a: 'Ja. Das Spiel selbst braucht kein Netz – braue Tränke im Flugzeug oder unter der Kuscheldecke. Internet brauchst du nur für Käufe und optionale Belohnungsvideos.' },
      { q: 'Gibt es Werbung?', a: 'Nur freiwillige. Es gibt keine Banner und keine Pop-up-Werbung zwischen den Bildschirmen. An einigen Stellen kannst du, wenn du willst, ein kurzes Video ansehen und einen Bonus bekommen – zum Beispiel Mana. Nichts im Spiel zwingt dich, sie anzusehen. Die Videos stammen von Google AdMob; mehr dazu in der Datenschutzerklärung.' },
      { q: 'Für welche Plattformen gibt es Qevryno?', a: 'iOS und Android, auf Deutsch, Englisch, Russisch, Spanisch, Französisch, Niederländisch, Italienisch, Portugiesisch (Brasilien), Polnisch, Japanisch, Koreanisch, Chinesisch (traditionell) und Türkisch.' },
      { q: 'Ist das Spiel gruselig oder stressig?', a: 'Überhaupt nicht. Ein ruhiges, gemütliches Spiel: sanfte Musik, keine Strafen für Fehler und ein Kater mit Hut.' },
    ],
  },
  contact: {
    title: 'Schreib uns',
    subtitle: 'Eine Frage zu Qevryno, ein Fehler, ein Kauf oder Werbung? Schreib uns eine E-Mail.',
    write: 'E-Mail schreiben',
    mailSubject: 'Qevryno: Support',
    tip: 'Schreib dazu, welches Gerät du hast und was passiert ist – so können wir dir leichter helfen.',
    info: {
      title: 'Kontaktdaten',
      email: 'E-Mail',
      security: 'Sicherheit',
      legalName: 'Entwicklerin',
      address: 'Adresse',
    },
    refunds: {
      title: 'Erstattungen und Käufe',
      description: 'Alle Käufe laufen über den Apple App Store oder Google Play. Für eine Erstattung wende dich an den Store:',
      apple: 'Apple App Store',
      appleUrl: 'https://support.apple.com/de-de/HT204084',
      google: 'Google Play',
      googleUrl: 'https://support.google.com/googleplay/answer/2479637?hl=de',
      link: 'Erstattung anfordern',
      note: 'Wir nehmen selbst keine Zahlungen entgegen und können kein Geld erstatten. Wenn ein Kauf nicht im Spiel angekommen ist, öffne „Einstellungen → Käufe wiederherstellen“ oder schreib uns.',
    },
  },
  legal: {
    dataController: 'Verantwortlicher',
    // Политика и условия есть на английском, русском и испанском; для остальных языков страница показывает английский текст и эту строку
    onlyIn: 'Dieses Dokument gibt es nur auf Englisch, Russisch und Spanisch. Unten steht die englische Fassung.',
  },
};
